import React from "react";

const AboutPage = () => {
  return (
    <div className="">
      <h1 className="text-5xl lg:text-6xl font-bold text-center mb-8 lg:mb-16">
        About Me
      </h1>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 lg:gap-36">
        <div className="">
         
          <h1><span className="text-3xl font-bold">Hello there, </span>I'm Farhat, an experienced Web Developer with a demonstrated history of working in the internet industry. Skilled in REACT.js, Express.Js, MongoDB, Node.Js, Shopify, and WordPress. Strong arts and design professional with a CSE focused in Computer Engineering from United International University.</h1><br />
          <h2>I've worked as a freelance developer in Upwork and Fiverr since 2020 with a good number of clients all over the world. I've started my journey with WordPress but as days went by, I joined the coder tribe and taught myself how to code effeciently.</h2>
        </div>
        <div className="">
        <h1 className="text-3xl font-bold mb-8">Technologies I used</h1>
        <p><span className="font-bold">Frontend : </span>  HTML5, CSS3, Bootstrap, TailwindCss, MaterialUI, React.Js, Firebase</p>
        <p><span className="font-bold">Backend : </span> Express.Js, Node.Js, JWT, MongoDB</p>
        <p><span className="font-bold">Tools : </span> VsCode, Figma, NPM, Chrome Dev Tool, Netlify</p>
        <p><span className="font-bold">CMS : </span>WordPress & Shopify</p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
